module.exports = __webpack_public_path__ + "static/media/01-Rietberg@3x.b3e7836a.jpg";